import styled from 'styled-components';
import { palette } from 'styled-theme';

const StyledSteps = (ComponentName) => styled(ComponentName)`
  .ant-steps-item-error {
    .ant-steps-item-icon {
      background: transparent !important;
      border-color: red !important;
    }
  }
  & .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-finish) {
    .ant-steps-item-icon {
      background: transparent !important;
      border-color: ${palette('rebrandBlue', 3)} !important;
      > span {
        color: ${palette('foreground', 0)};
      }
    }
  }

  .ant-steps-item-active {
    .ant-steps-item-icon {
      background: ${palette('background', 61)} !important;
      border-color: ${palette('background', 61)} !important;
    }
  }
  .ant-steps-item-title {
    font-size: 14px;
    color: ${palette('foreground', 2)} !important;
  }
  .ant-steps-item-rail {
    background-color: ${palette('foreground', 2)} !important;
    border-color: ${palette('foreground', 2)} !important;
    border-block-start-width: 1px !important;
    transform: translateY(-50%) scaleY(0.5) !important;
  }
`;

export default StyledSteps;
